var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-label-group",class:_vm.className,attrs:{"title":_vm.title ? _vm.title : _vm.$t('notFound')}},[_c('b-form-datepicker',_vm._b({staticClass:"form-control",attrs:{"id":_vm.id,"date-format-options":{
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      weekday: 'short',
    },"placeholder":_vm.title ? _vm.title : _vm.$t('notFound'),"locale":_vm.language,"today-button":"","reset-button":""},model:{value:(_vm.theValue),callback:function ($$v) {_vm.theValue=$$v},expression:"theValue"}},'b-form-datepicker',_vm.labels[_vm.language] || {},false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }